var map = {
	"./01.jpg": 512,
	"./02.jpg": 513,
	"./03.jpg": 514,
	"./04.jpg": 515,
	"./05.jpg": 516,
	"./06.jpg": 517,
	"./08.jpg": 518,
	"./09.jpg": 519
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 965;


//////////////////
// WEBPACK FOOTER
// ./static/images/agc/gallery \.(jpg)$
// module id = 965
// module chunks = 0